import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { scrollToControl } from './_controls';
// Marks a control inside a page preview. While the page shows labels, the spot is outlined and
// tagged with what it is; the tag jumps to that control's entry in the list below the previews.
const ShowcaseSpot = (props) => {
    var _a;
    return _jsx(_Fragment, { children: _jsxs("div", { className: `theme-showcase__spot${props.tagAtEnd ? ' theme-showcase__spot--tag-end' : ''} ${(_a = props.className) !== null && _a !== void 0 ? _a : ''}`, children: [_jsx("button", { type: "button", className: "theme-showcase__spot-tag", "aria-label": `${props.label}: see it in the control list`, onClick: () => scrollToControl(props.control), children: props.label }), props.children] }) });
};
export default ShowcaseSpot;
